import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import type { Translation, TranslocoLoader } from "@jsverse/transloco";
import type { Observable } from "rxjs";

@Injectable({ providedIn: "root" })
export class TranslocoHttpLoader implements TranslocoLoader {
    constructor(private readonly http: HttpClient) {}

    getTranslation(lang: string, data?: { scope: string }): Observable<Translation> {
        const scope = data?.scope;
        let fileLang = lang;
        if (scope && lang.startsWith(`${scope}/`)) {
            fileLang = lang.slice(scope.length + 1);
        }
        const path = scope
            ? `assets/i18n/${scope}/${fileLang}.json`
            : `assets/i18n/${fileLang}.json`;
        return this.http.get<Translation>(path);
    }
}
